import store from "store2";
import ky from "ky";

import config from "./config";

const client = ky.create({
  prefixUrl: config.apiUrl,
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set("Authorization", `Bearer ${store.get("token")}`);
        request.headers.set("x-client", "intercom");
      },
    ],
  },
});

export default client;
